import React from 'react';
import { graphql } from 'gatsby';
import PageTemplate from '../../../templates/Informational';
import SEO from '../../../templates/SEO';
import LDP from '../../../components/pages/locations-detail/LDP';

/**
 * @param {Object} props
 * @param {{ fridgeLocation: FF.Location__LDP}} props.data
 * @param {string} props.path
 */
function FridgeLocationDetailsPage({ data, path }) {
  return (
    <PageTemplate path={path}>
      <LDP locationData={data.fridgeLocation} />
    </PageTemplate>
  );
}

export default FridgeLocationDetailsPage;

/**
 * @param {object} props
 * @param {{fridgeLocation: FF.Location__LDP}} props.data
 */
export function Head({ data: { fridgeLocation } }) {
  const { prettyName } = fridgeLocation.locationConfigs;
  return (
    <SEO
      description={`Find the location address, hours, & other details for ${prettyName}!`}
      pageTitle={`Location Details for ${prettyName}`}
    />
  );
}

export const pageQuery = graphql`
  query fridgeLocationData($fridgeId: String) {
    fridgeLocation(fridgeId: { eq: $fridgeId }) {
      id
      fridgeId
      locationConfigs {
        accessTo
        coordinates {
          latitude
          longitude
        }
        prettyName
        pricingSchema
        reserve
        timeZone
        vertical
        workHours
      }
      operationConfigs {
        address
        addressLines {
          addressLine1
          addressLine2
          city
          stateCode
          zipCode
        }
        directions
      }
      featureFlags {
        holidayType
        isGrandOpening
        isHolidayMode
        isLowTierDiscount
        isMidTierDiscount
      }
      type
      fridgeSpecificMenuPagePath: gatsbyPath(
        filePath: "/locations/{fridgeLocation.fridgeId}/menu"
      )
      LDPPagePath: gatsbyPath(filePath: "/locations/{fridgeLocation.fridgeId}")
    }
  }
`;
